import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { FC, useMemo } from "react";
import { Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import casesService from "api/casesService";
import Button from "components/Button";
import { useNavigate } from "react-router-dom";
import CaseView from "components/CaseView";
import tagsService from "api/tagsService";
import statusService from "api/statusService";

const CasePreviewModal: FC<Props> = ({ caseId, toggle }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: Case } = casesService.useGetCase(caseId);

  const navigateToCase = () => {
    navigate(`/cases/${caseId}`);
  };

  const { data: tagsData } = tagsService.useGetTags();
  const tags = useMemo(() => tagsData?.data ?? [], [tagsData]);
  const { data: statusesData } = statusService.useGetStatuses();
  const statuses = useMemo(() => statusesData?.data ?? [], [statusesData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {t("modals.case")}
        <CloseIcon onClick={() => toggle(false)} className={styles.closeIcon} />
      </div>
      <div className={styles.content}>
        {Case && (
          <CaseView
            caseIdFromProps={caseId}
            createNewThread={false}
            tags={tags}
            statuses={statuses}
            selectedThread={null}
            setSelectedThread={() => {}}
            setCreateNewThread={() => {}}
            showCase
          ></CaseView>
        )}
        <div className={styles.absoluteButtons}>
          <Button text={t("cases.goToCase")} onClick={navigateToCase}></Button>
        </div>
      </div>
    </div>
  );
};

export default CasePreviewModal;
